export enum ProfileCardTab {
  LEARNING = 'learning',
  REWARDS = 'rewards',
}

export enum CardTimePeriodFilterOptions {
  ALL_TIME = 'all-time',
  LAST_7_DAYS = 'last-7-days',
  LAST_30_DAYS = 'last-30-days',
  DAYS_90_DAYS = 'last-90-days',
  LAST_YEAR = 'last-year',
}

export enum MathCategoryFilterOptions {
  ALL_MATH_CATEGORIES = 'all',
  ALGEBRA = 'algebra',
  GEOMATRY = 'geometry',
  NUMBERS_AND_QUANTITIES = 'numbers-and-quantities',
  STATISTICS_AND_PROBABILITY = 'statistics-and-probability',
  FUNCTIONS = 'functions',
  PROOFS = 'proofs',
}

export enum ProductCardFilterOptions {
  VIDEO_CRASH_COURSES = 'video-crash-courses',
  MATH_VAULT = 'math-vault',
  MATH_ESSENTIALS = 'math-essentials',
  GAMES = 'games',
  CURRICULUM = 'curriculum',
  TESTS = 'tests',
}

export enum Size {
  SMALL = 'sm',
  LARGE = 'lg',
}

export interface LearningStats {
  activitiesDone: number
  activityAccuracy: number
  bestActivityAccuracy: number
  totalTimeSpent: number
  watchedVideoDuration: number
}

export interface LearningStatsAPI {
  activities: {
    correctAnswers: number
    wrongAnswers: number
    bestActivityAccuracy: number
    noActivities: boolean
  }
  timeSpent: number
  watchedVideoDuration: number
  watchedVideoCount: number
}

export interface Gems {
  red: number
  blue: number
  green: number
}

export interface RewardsStats {
  chest: {
    opened: number
    total: number
  }
  gems: number
  kudos: number
  xp: number
}
